import React, { useContext } from 'react';
import axios from 'axios';
import { Link } from '@reach/router';
import { MedataContext } from '../../../../../../ContexMedata';

function FileDownload({ title, hasPreview, format, downloadURL, id, description }) {

  const { datasetDonwloads, setDatasetDonwloads } = useContext(MedataContext);
  var label = title || format;
  const buttonStyle = (!hasPreview) ? { justifyContent: 'flex-start' } : {};

  const currentUrl = window.location.href;

  const finalUrl = (currentUrl.startsWith('https://') ? ((downloadURL.startsWith('http://') >= 0) ? downloadURL.replace('http://', 'https://') : downloadURL) : downloadURL);

  // Registra la descarga en el backend: incrementa el contador y guarda la
  // referencia geográfica (país) por zona horaria del navegador, sin usar la IP
  // (privacidad). Reemplaza el PATCH directo a JSON:API que exponía credenciales
  // de escritura en el bundle JS.
  const downloadsFunc = async () => {
    let timezone = '';
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {
      timezone = '';
    }

    try {
      const { data } = await axios.post(`/api/dataset/${id}/descarga`, { timezone });
      if (data && typeof data.descargas !== 'undefined') {
        setDatasetDonwloads(data.descargas);
      }
    } catch (error) {
      // No bloquear la descarga si el registro falla.
      console.error('Error al registrar la descarga:', error);
    }
  }


  return (
    <div className='data-actions pl-2'>
      <a href={finalUrl} title={label} className='button button-secondary' onClick={() => downloadsFunc()}>
        <i className='fa-solid fa-download'>
        </i>
        {` ${label}`}
      </a>
    </div>
  )

}

export default FileDownload